import { SatisfactionState, state } from './state';
import { mutations } from './mutations';
import { getters } from './getters';

const SatisfactionModule = {
    namespaced: true,
    state,
    mutations,
    getters
};
export default SatisfactionModule;
export type { SatisfactionState };
